

export default function ToastEvent(message, severity) {
	var event = new CustomEvent("toast", { detail: { message: message, severity: severity } });
	document.dispatchEvent(event);
}

